import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      '& h6': {
        color: (props: { completed: boolean; featured: boolean }) =>
          props.completed === true ? `${colors.black}` : `${colors.darkGrey}`,
        fontFamiy: 'Open Sans',
        paddingTop: 5,
      },
      border: (props: { featured: boolean; completed: boolean }) =>
        props.featured === true
          ? `1px solid ${colors.resiliaGreen}`
          : `1px solid ${colors.lightGrey}`,
      '& h5': {
        color: colors.resiliaBlue,
        fontWeight: 600,
      },

      backgroundColor: colors.resiliaWhite,
      borderRadius: 4,
      margin: 10,
      minWidth: 242,
      width: 242,
      height: 242,
      position: 'relative',
    },
    title: {
      textAlign: 'center',
    },
    featuredIcon: {
      color: colors.resiliaBlue,
    },
    standardIcon: {
      color: colors.grey,
    },
    divider: {
      border: (props: { completed: boolean; featured: boolean }) =>
        props.completed === true
          ? `4px solid ${colors.resiliaGreen}`
          : `4px solid ${colors.lightestGrey}`,
      borderRadius: 7,
      position: 'absolute',
      width: 200,
      bottom: 0,
      marginBottom: 20,
      background: (props: { completed: boolean; featured: boolean }) =>
        props.completed === true ? colors.resiliaGreen : colors.lightestGrey,
    },
    iconContainer: {
      fontSize: 65,
      textAlign: 'center',
    },
  })
)
export default useStyles
